module.exports = __webpack_public_path__ + "static/chat-bubble-dude-86a1615fc38b0ec55e91b36338748c72.png";